/**
 * 销售管理 经理工作平台 mock
 * http://mockjs.com/
 url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 业务统计
Mock.mock(/sale_potential_customer\/pending_approve_summary/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'pending_approve_deal_num': 10,
    'pending_approve_fail_num': 10
  },
  'message': 'ok'
})
// 业务统计
Mock.mock(/sale_potential_customer\/statistics/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'call_num': 20,
    'contact_customer_num': 30,
    'deal_num': 40,
    'first_time_reception_num': 50,
    'overdue_task_num': 60,
    'reception_num': 70,
    'sign_bill_num': 80
  },
  'message': 'ok'
})

// 所有销售人员
Mock.mock(/sale_potential_customer\/sales/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'avatar': 'https://test-images-cdn.cheanjia.com/image/v1/nmfqiurqlppvszzpolfzckjmunha.jpg',
      'id': 1,
      'name': 'marry'
    },
    {
      'avatar': 'https://test-images-cdn.cheanjia.com/image/v1/nmfqiurqlppvszzpolfzckjmunha.jpg',
      'id': 2,
      'name': 'lucy'
    },
    {
      'avatar': 'https://test-images-cdn.cheanjia.com/image/v1/nmfqiurqlppvszzpolfzckjmunha.jpg',
      'id': 3,
      'name': 'lily'
    },
    {
      'avatar': 'https://test-images-cdn.cheanjia.com/image/v1/nmfqiurqlppvszzpolfzckjmunha.jpg',
      'id': 4,
      'name': 'gary'
    }, {
      'avatar': 'https://test-images-cdn.cheanjia.com/image/v1/nmfqiurqlppvszzpolfzckjmunha.jpg',
      'id': 5,
      'name': 'david'
    }, {
      'avatar': 'https://test-images-cdn.cheanjia.com/image/v1/nmfqiurqlppvszzpolfzckjmunha.jpg',
      'id': 6,
      'name': 'hky'
    }
  ],
  'message': 'ok'
})

// 所有成交记录
Mock.mock(/sale_potential_customer\/signed_and_deal/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customers': [
      {
        'buy_type': '购买类型1',
        'customer_mobile_number': '15002056658',
        'customer_name': '哈哈哈哈',
        'deposit': 10000,
        'id': 11123123123131,
        'intention_cars': [
          '宝马',
          '奔驰',
          '呃呃呃'
        ],
        'pay_type': '付款方式',
        'remark': '其他备注',
        'sales': '销售顾问1',
        'signed_at': '提交时间',
        'status': 2
      },
      {
        'buy_type': '购买类型2',
        'customer_mobile_number': '15002056658',
        'customer_name': '哈哈哈哈',
        'deposit': 10000,
        'id': 11123123123131,
        'intention_cars': [
          '宝马',
          '奔驰',
          '呃呃呃'
        ],
        'pay_type': '付款方式',
        'remark': '其他备注',
        'sales': '销售顾问2',
        'signed_at': '提交时间',
        'status': 3
      },
      {
        'buy_type': '购买类型2',
        'customer_mobile_number': '15002056658',
        'customer_name': '哈哈哈哈',
        'deposit': 10000,
        'id': 11123123123131,
        'intention_cars': [
          '宝马',
          '奔驰',
          '呃呃呃'
        ],
        'pay_type': '付款方式',
        'remark': '其他备注',
        'sales': '销售顾问3',
        'signed_at': '提交时间',
        'status': 4
      }
    ],
    'total': 100
  },
  'message': 'ok'
})

// 未成交(驳回)
Mock.mock(/sale_potential_customer\/reject_deal\/\d+$/, 'post' + mockSwitch, {
  'code': 0,
  'data': {},
  'message': 'ok'
})

// 确认成交
Mock.mock(/sale_potential_customer\/confirm_deal\/\d+$/, 'post' + mockSwitch, {
  'code': 0,
  'data': {},
  'message': 'ok'
})

// 战败审核列表
Mock.mock(/sale_potential_customer\/fail_and_pending/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customers': [
      {
        'customer_mobile_number': '客户电话号码1',
        'customer_name': '客户姓名1',
        'fail_reason': '失败原因',
        'id': 123123120,
        'request_fail_at': '提交时间',
        'sales': '销售顾问',
        'status': 1
      },
      {
        'customer_mobile_number': '客户电话号码2',
        'customer_name': '客户姓名2',
        'fail_reason': '失败原因',
        'id': 123123120,
        'request_fail_at': '提交时间',
        'sales': '销售顾问',
        'status': 1
      }, {
        'customer_mobile_number': '客户电话号码3',
        'customer_name': '客户姓名3',
        'fail_reason': '失败原因',
        'id': 123123120,
        'request_fail_at': '提交时间',
        'sales': '销售顾问',
        'status': 1
      }, {
        'customer_mobile_number': '客户电话号码4',
        'customer_name': '客户姓名4',
        'fail_reason': '失败原因',
        'id': 123123120,
        'request_fail_at': '提交时间',
        'sales': '销售顾问',
        'status': 1
      }
    ],
    'total': 110
  },
  'message': 'ok'
})

// 审核通过(确认战败)
Mock.mock(/sale_potential_customer\/confirm_fail\/\d+$/, 'post' + mockSwitch, {
  'code': 0,
  'data': {},
  'message': 'ok'
})

// 审核不通过
Mock.mock(/sale_potential_customer\/reject_fail\/\d+$/, 'post' + mockSwitch, {
  'code': 0,
  'data': {},
  'message': 'ok'
})
